module.exports = __webpack_public_path__ + "img/2d-plan.043096c3.jpg";